import { MODE_TRANSFER } from '@/lib/constants';
import { SegmentLinkModel, SegmentTransferModel } from '@/lib/models/segment/types';

export const getIsSegmentTransfer = (segment: SegmentLinkModel | SegmentTransferModel): boolean => {
  return segment.routeType === MODE_TRANSFER;
};
